import { styled } from "@mui/material/styles";
import Divider from "@mui/material/Divider";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import LoadingButton from "@mui/lab/LoadingButton";

export const SettingsFormContainer = styled(Box)({
	// paddingRight: "20%",
});

export const SectionDivider = styled(Divider)({
	margin: "20px 0",
});

export const SectionHeading = styled(Typography)({
	marginBottom: "15px",
});

export const FieldsContainer = styled(Paper)({
	display: "flex",
	flexDirection: "column",
	padding: "20px",
});

export const TextFieldContainer = styled(Box)({
	display: "flex",
	justifyContent: "space-between",
	margin: "10px 0",
});

export const FieldLabel = styled(Typography)({
	fontSize: "1rem",
	margin: "15px 0",
});

export const TextInput = styled(TextField)({
	marginBottom: "15px",
});

export const SaveSettingButton = styled(LoadingButton)({
	marginTop: "36px",
});
